function Button (props){
  const{text, type}=props
  return(
    <button id="Button" className={`btn ${type}`}>
      {text}
    </button>
  )
}

export default Button;